const MESSAGE = "Alleen hele getallen zijn toegestaan.";

export default (value: string) => value && !/^\d+$/.test(value) ? MESSAGE : undefined;
